<template>
    <div class="submenu_permission">
        <!-- Background Shapes -->
        <div class="background-shapes">
            <div class="shape triangle-1"></div>
            <div class="shape triangle-2"></div>
            <div class="shape circle"></div>
        </div>
        <div class="menu-form">
            <b-card class="rounded text-white bg-success fa-1x shadow-lg">
                <h3>Feature Permissions</h3>
            </b-card>

            <div class="card-body">
                <div class="row">
                    <!-- User Selection -->
                    <div class="user-card mt-4">
                        <div class="col-md-3 col-sm-4 mt-4">
                            <b-form-group label="Please Select a Role" label-for="select_user" class="mt-4">
                                <b-form-select
                                        id="select_user"
                                        v-model="booleanValue"
                                        :options="options"
                                        text-field="label"
                                        value-field="value"
                                />
                            </b-form-group>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-6 mt-4 menu-card">
                        <div class="card border-0">
                            <div class="card-header bg-success text-white text-center">
                                <h4 class="mb-0">Applications Menus</h4>
                            </div>
                            <!--<div class="card-body" v-if="allRole  && allRole.length">
                                <div v-for="(roles, index) in allRole" :key="index">
                                    <div class="mb-3" v-if="roles">
                                        {{roles}}
                                        <a
                                                type="button"
                                                :class="[ 'btn', 'btn-outline-success', 'btn-block', 'role-button',
                                                { 'selected': selectedRole && selectedRole[index].id === roles[index].id }
                                              ]"
                                                @click="permissionValue(roles[index].requestKey)"
                                        >
                                            {{ roles.name }}
                                        </a>
                                    </div>
                                </div>
                            </div>-->

                            <div class="card-body" v-if="allRole && allRole.length">
                                <div v-for="(role, index) in allRole" :key="index" class="mb-3">
                                    <a
                                            type="button"
                                            :class="[ 'btn', 'btn-outline-success', 'btn-block', 'role-button', { selected: selectedRoleIndex === index } ]"
                                            @click="selectRole(role, index)"
                                    >
                                        {{ role.name }}
                                    </a>
                                </div>
                            </div>

                            <div class="card-body" v-else>
                                <p class="card-header text-center bg-light text-success">No Data Found!!</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 mt-4 menu-card" v-if="allRole && allRole.length">
                        <b-form :key="selectedRole?.id" @submit.prevent="onSubmit" @reset.prevent="">
                            <button type="submit" class="btn btn-success">Save</button>
                            <div class="checkbox-group mt-4" v-for="(data, index) in getRoleOptions" :key="index">
                                <label class="custom-checkbox" :for="'checkbox-' + index">
                                    <input type="checkbox"
                                           :id="'checkbox-' + index"
                                           :value="data.id"
                                           v-model="selectedPermissions">
                                    {{ data.contextName }}
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </b-form>
                    </div>

                    <!--<div class="col-md-4 col-sm-6 mt-4 menu-card" v-if="allRole && allRole.length">
                        <b-form @submit.prevent="onSubmit" @reset.prevent="">
                            <button type="submit" class="btn btn-success">Save</button>
                            <div class="checkbox-group mt-4" v-for="(data, index) in getRoleOptions" :key="index">
                                <label class="custom-checkbox">
                                    <input type="checkbox"
                                           id="flexCheckDefault"
                                           :value="data.id"
                                           v-model="selectedPermissions">
                                    {{data['contextName']}}
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </b-form>
                    </div>-->
                    <div class="col-md-4 col-sm-6 mt-4 menu-card" v-else>
                        <div class="card-body">
                            <p class="card-header text-success text-center mt-5 p-2">No data found!!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import apiRepository from "@/services/ApiRepository";
    import {toast} from 'vue3-toastify';

    export default {
        name: 'subMenu',
        data() {
            return {
                booleanValue: null,
                allRole: null,
                selectedPermissions: [],
                selectedRoleIndex: null,
                selectedRole: null,
                options: [
                    {label: 'Select One', value: null, disabled: true},
                    {label: 'Witness', value: 1},
                    {label: 'Nominee', value: 2}
                ],
                getRoleOptions: [],
                getMenuAccess: [],
            }
        },
        mounted() {
            // this.permissionVlu();
        },
        watch: {
            booleanValue(newVal) {
                if (!newVal) {
                    toast.error('No role selected');
                    return;
                }
                apiRepository.getUsersByRole(newVal).then((res) => {
                    if (res && res.data) {
                        this.allRole = res.data;
                        this.onReset();
                    }
                }).catch((err) => {
                    console.error('Error fetching roles:', err);
                });
            }
        },
        methods: {
            selectRole(role, index) {
                this.selectedRoleIndex = index;
                this.permissionValue(role);
            },
            permissionValue(role) {
                this.selectedRole = role;
                this.requestKey = role.requestKey;

                apiRepository.permissionVlu().then((res) => {
                    this.getRoleOptions = res.data;

                    apiRepository.getUserContext(this.requestKey, false).then((response) => {
                        if (response) {
                            this.getMenuAccess = response.data;
                            const selectedKeys = this.getMenuAccess.map(item => item.key);
                            this.selectedPermissions = this.getRoleOptions
                                .filter(option => selectedKeys.includes(option.id))
                                .map(option => option.id);
                        } else {
                            this.selectedPermissions = [];
                        }
                    }).catch((error) => {
                        console.error(error.response.data);
                        this.selectedPermissions = [];
                    });
                });
            },

            /* permissionValue(role) {
                 this.selectedRole = role;
                 this.requestKey = role.requestKey;

                 apiRepository.permissionVlu().then((res) => {
                     this.getRoleOptions = res.data;

                     apiRepository.getUserContext(this.requestKey, false).then((response) => {
                         if (response) {
                             this.getMenuAccess = response.data;
                             const selectedKeys = this.getMenuAccess.map(item => item.key);
                             this.selectedPermissions = this.getRoleOptions.filter(option => selectedKeys.includes(option.id)).map(option => option.id);
                         }
                     }).catch((error) => {
                         console.error(error.response.data);
                     });
                 })
             },*/

            onSubmit() {
                // const selectedIds = this.selectedPermission.join(',');
                const selectedIds = this.selectedPermissions.map(id => parseInt(id));
                const selectedRoleName = this.selectedRole?.requestKey || 'No role selected';
                const selectUser = this.booleanValue

                if (selectedIds.length === 0) {
                    toast.error('Mandatory fields cannot be null or empty!')
                    return;
                }
                const payload = {
                    requestKey: selectedRoleName,
                    contextIds: selectedIds
                };
                apiRepository.assignContextData(payload, selectUser).then((response) => {
                    if (response) {
                        toast.success(response.data)
                    }
                }).catch((e) => {
                    toast.error(e.response.data);
                })
            },
            onReset() {
                // this.selectedPermissions = null
                // this.getRoleOptions = null
            }
        }
    }
</script>

<style scoped>
    /* Card Styling */
    .menu-card {
        margin-left: 60px !important;
    }

    .user-card, .menu-card {
        background: white;
        gap: 40px;
        padding: 20px;
        border-radius: 15px;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
        position: relative;
        z-index: 1;
    }

    /* Save Button with Glow Effect */
    .btn-glow {
        background: #077747;
        color: white;
        padding: 8px 15px;
        border-radius: 25px;
        font-weight: bold;
        transition: 0.3s ease-in-out;
        box-shadow: 0px 4px 10px rgba(0, 255, 0, 0.4);
    }

    .btn-glow:hover {
        background: #218838;
        box-shadow: 0px 6px 15px rgba(0, 255, 0, 0.6);
    }

    /* Custom Checkbox */
    .custom-checkbox {
        display: flex;
        align-items: center;
        font-size: 18px;
        cursor: pointer;
        margin-bottom: 10px;
        position: relative;
        padding-left: 30px;
        color: #444;
        transition: 0.3s;
    }

    .custom-checkbox input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    .custom-checkbox .checkmark {
        position: absolute;
        left: 0;
        height: 20px;
        width: 20px;
        background: white;
        border: 2px solid #28a745;
        border-radius: 5px;
        transition: 0.3s;
    }

    .custom-checkbox:hover .checkmark {
        background: #28a745;
    }

    .custom-checkbox input:checked ~ .checkmark {
        background: #28a745;
    }

    .custom-checkbox .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .custom-checkbox input:checked ~ .checkmark:after {
        display: block;
    }

    .custom-checkbox .checkmark:after {
        left: 7px;
        top: 3px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    /*background style*/
    .submenu_permission {
        position: relative;
        padding: 2rem;
        background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
        border-radius: 15px;
        overflow: hidden;
    }

    .background-shapes {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    .shape {
        position: absolute;
        background: rgba(255, 255, 255, 0.3);
    }

    .triangle-1 {
        width: 0;
        height: 0;
        border-left: 100px solid transparent;
        border-right: 100px solid transparent;
        border-bottom: 200px solid rgba(255, 99, 71, 0.3);
        top: -50px;
        left: -50px;
        transform: rotate(45deg);
    }

    .triangle-2 {
        width: 0;
        height: 0;
        border-left: 80px solid transparent;
        border-right: 80px solid transparent;
        border-bottom: 160px solid rgba(70, 130, 180, 0.3);
        bottom: -80px;
        right: -80px;
        transform: rotate(-30deg);
    }

    .circle {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: rgba(144, 238, 144, 0.3);
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .menu-form {
        position: relative;
        z-index: 2;
        /*background: rgba(255, 255, 255, 0.9);*/
        padding: 2rem;
        border-radius: 10px;
        /*box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);*/
        animation: fadeIn 0.5s ease-in-out;
    }

    /*role design */

    /* Custom button styling */
    .role-button {
        width: 100%;
        text-transform: uppercase;
        font-weight: bold;
        padding: 5px 20px;
        font-size: 16px;
        border-radius: 5px;
        transition: all 0.3s ease;
    }

    /* Hover effect for buttons */
    .role-button:hover {
        width: 100%;
        background-color: #077747; /* Green shade */
        color: white;
        transform: translateY(-2px);
    }

    /* When a button is selected */
    .role-button.selected {
        width: 100%;
        background-color: #077747; /* Green shade */
        color: white;
        font-weight: bold;
    }

</style>
